import { render, staticRenderFns } from "./Student.vue?vue&type=template&id=bfb21d88&scoped=true"
import script from "./Student.vue?vue&type=script&lang=js"
export * from "./Student.vue?vue&type=script&lang=js"
import style0 from "./Student.vue?vue&type=style&index=0&id=bfb21d88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb21d88",
  null
  
)

export default component.exports